"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderUsdValue = exports.OrderTokenDisplay = exports.StyledPreviewLinearProgress = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var __1 = require("../..");
var styles_1 = require("../../styles");
var hooks_1 = require("../../hooks");
var base_1 = require("../../components/base");
var HiArrowRight_1 = require("@react-icons/all-files/hi/HiArrowRight");
var FiChevronDown_1 = require("@react-icons/all-files/fi/FiChevronDown");
function OrderPreview(_a) {
    var _b;
    var order = _a.order, expanded = _a.expanded;
    var _c = (0, hooks_1.useOrderPastEvents)(order, expanded), data = _c.data, isFetching = _c.isFetching;
    var srcFilledAmountUi = (0, hooks_1.useFormatNumber)({ value: order.ui.srcFilledAmountUi });
    var progress = (0, hooks_1.useFormatNumber)({ value: order.ui.progress, decimalScale: 1, suffix: "%" });
    var translations = (0, __1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ gap: 0, className: "twap-order-preview" }, { children: [(0, jsx_runtime_1.jsxs)(StyledHeader, __assign({ className: "twap-order-preview-header" }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ className: "twap-order-preview-info", gap: 6, justifyContent: "flex-start", style: { width: "auto" } }, { children: [(0, jsx_runtime_1.jsxs)(StyledHeaderText, { children: ["#", order.order.id] }), (0, jsx_runtime_1.jsx)(StyledHeaderText, { children: order.ui.isMarketOrder ? translations.marketOrder : translations.limitOrder })] })), (0, jsx_runtime_1.jsx)(StyledHeaderText, __assign({ className: "twap-order-preview-date" }, { children: order.ui.createdAtUi }))] })), (0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ childrenStyles: { width: "100%" }, placement: "top", text: (0, jsx_runtime_1.jsxs)(material_1.Box, { children: [srcFilledAmountUi, " " + ((_b = order.ui.srcToken) === null || _b === void 0 ? void 0 : _b.symbol) + " ", "(".concat(progress ? progress : "0%", ")")] }) }, { children: (0, jsx_runtime_1.jsx)(exports.StyledPreviewLinearProgress, { variant: "determinate", value: order.ui.progress || 1, className: "twap-order-progress twap-order-preview-progress" }) })), (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ style: { paddingTop: 18, paddingRight: 10, alignItems: "flex-start", gap: 16 }, className: "twap-order-preview-tokens", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(exports.OrderTokenDisplay, { isMain: true, token: order.ui.srcToken, amount: order.ui.srcAmountUi, usdValue: order.ui.srcAmountUsdUi }), (0, jsx_runtime_1.jsx)(base_1.Icon, { className: "twap-order-preview-icon", icon: (0, jsx_runtime_1.jsx)(HiArrowRight_1.HiArrowRight, { style: { width: 22, height: 22 } }) }), (0, jsx_runtime_1.jsx)(exports.OrderTokenDisplay, { isLoading: isFetching, token: order.ui.dstToken, amount: data === null || data === void 0 ? void 0 : data.dstAmountOut, usdValue: (data === null || data === void 0 ? void 0 : data.dstAmountOutUsdPrice) || "", icon: (0, jsx_runtime_1.jsx)(FiChevronDown_1.FiChevronDown, {}) })] }))] })));
}
exports.default = OrderPreview;
exports.StyledPreviewLinearProgress = (0, material_1.styled)(material_1.LinearProgress)({
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    background: "transparent",
    height: 7,
    "&::after": {
        position: "absolute",
        top: "50%",
        left: 0,
        height: 1,
        content: '""',
        width: "100%",
        background: "#373E55",
    },
    "& .MuiLinearProgress-bar": {
        height: "100%",
        zIndex: 1,
        transition: "0.2s all",
    },
});
var StyledHeader = (0, material_1.styled)(styles_1.StyledRowFlex)({
    justifyContent: "space-between",
    fontSize: 13,
    fontWeight: 300,
    marginBottom: 12,
});
var StyledHeaderText = (0, material_1.styled)(styles_1.StyledText)({
    fontSize: "inherit",
    fontWeight: "inherit",
    color: "#9CA3AF",
});
var OrderTokenDisplay = function (_a) {
    var token = _a.token, amount = _a.amount, _b = _a.prefix, prefix = _b === void 0 ? "" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, usdValue = _a.usdValue, alighLeft = _a.alighLeft, usdPrefix = _a.usdPrefix, icon = _a.icon, isLoading = _a.isLoading;
    var tokenAmount = (0, hooks_1.useFormatNumber)({ value: amount });
    var tokenAmountTooltip = (0, hooks_1.useFormatNumber)({ value: amount, decimalScale: 18 });
    return ((0, jsx_runtime_1.jsxs)(StyledTokenDisplay, __assign({ className: "twap-order-token-display ".concat(className) }, { children: [(0, jsx_runtime_1.jsxs)(StyledTokenDisplayFlex, { children: [(0, jsx_runtime_1.jsx)(StyledTokenLogo, { logo: token === null || token === void 0 ? void 0 : token.logoUrl }), (0, jsx_runtime_1.jsxs)(StyledTokenDisplayAmount, { children: [amount ? ((0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: "".concat(tokenAmountTooltip, " ").concat(token === null || token === void 0 ? void 0 : token.symbol) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ className: "twap-order-token-display-amount" }, { children: [prefix ? "".concat(prefix, " ") : "", tokenAmount, " ".concat(token === null || token === void 0 ? void 0 : token.symbol)] })) }))) : ((0, jsx_runtime_1.jsx)(material_1.Typography, { children: " ".concat(token === null || token === void 0 ? void 0 : token.symbol) })), !alighLeft && (0, jsx_runtime_1.jsx)(OrderUsdValue, { isLoading: isLoading, usdValue: usdValue, prefix: usdPrefix })] }), icon && (0, jsx_runtime_1.jsx)(StyledIcon, { children: icon })] }), alighLeft && (0, jsx_runtime_1.jsx)(OrderUsdValue, { isLoading: isLoading, usdValue: usdValue, prefix: usdPrefix })] })));
};
exports.OrderTokenDisplay = OrderTokenDisplay;
var StyledIcon = (0, material_1.styled)("div")({
    position: "relative",
    top: 2,
    svg: {
        width: 20,
        height: 20,
    },
});
function OrderUsdValue(_a) {
    var usdValue = _a.usdValue, _b = _a.prefix, prefix = _b === void 0 ? "≈" : _b, isLoading = _a.isLoading;
    var formattedValue = (0, hooks_1.useFormatNumber)({ value: usdValue });
    var formattedValueTooltip = (0, hooks_1.useFormatNumber)({ value: usdValue, decimalScale: 18 });
    if (isLoading)
        return (0, jsx_runtime_1.jsx)(base_1.Loader, { width: 100, height: 20 });
    if (!usdValue)
        return null;
    return ((0, jsx_runtime_1.jsx)(StyledTokenDisplayUsd, __assign({ loading: false, className: "twap-order-token-display-usd" }, { children: (0, jsx_runtime_1.jsxs)(base_1.Tooltip, __assign({ text: "$ ".concat(formattedValueTooltip) }, { children: [prefix, " $ ", formattedValue] })) })));
}
exports.OrderUsdValue = OrderUsdValue;
var StyledTokenDisplayUsd = (0, material_1.styled)(base_1.SmallLabel)({
    fontSize: 13,
});
var StyledTokenDisplayAmount = (0, material_1.styled)(styles_1.StyledColumnFlex)({
    justifyContent: "flex-start",
    width: "auto",
    gap: 3,
    flex: 1,
    minWidth: 0,
    fontSize: "14px",
    ".twap-tooltip-children": __assign(__assign({ minWidth: 0 }, styles_1.textOverflow), { width: "100%" }),
    p: __assign({ fontSize: "inherit", minWidth: 0 }, styles_1.textOverflow),
});
var StyledTokenDisplayFlex = (0, material_1.styled)(styles_1.StyledRowFlex)({
    alignItems: "flex-start",
    flex: 1,
    gap: 8,
});
var StyledTokenDisplay = (0, material_1.styled)(styles_1.StyledColumnFlex)({
    flex: 1,
    gap: 3,
    width: "auto",
    alignItems: "flex-start",
    fontSize: 16,
    minWidth: 0,
});
var StyledTokenLogo = (0, material_1.styled)(base_1.TokenLogo)({
    width: 28,
    height: 28,
    top: -2,
    position: "relative",
    "@media(max-width: 600px)": {
        width: 20,
        height: 20,
    },
});
